const centerPanel = require('../../shop/views/center-panel.view.html').trim();

module.exports = ($stateProvider) => {
    $stateProvider
        .state('error', {
            parent: 'root',
            abstract: true,
            views: {
                'content@root': {
                    template: `${centerPanel}`,
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-error-instrumentation></wow-rr-error-instrumentation>',
                },
            },
        })
        .state('error.404', {
            url: '/resourcenotfound',
            views: {
                'center-panel': {
                    template: '<wow-error-page error-page=\'404\'></wow-error-page>',
                },
            },
            data: {
                pageMetadata: [
                    'PageMetadataService', function (pageMetadataService) {
                        const currentMetaData = pageMetadataService.getCurrentMetadata();
                        currentMetaData.meta404 = {
                            name: 'prerender-status-code',
                            content: '404',
                        };
                        return currentMetaData;
                    },
                ],
            },
        })
        .state('error.500', {
            url: '/error',
            views: {
                'center-panel@error': {
                    template: '<wow-error-page error-page=\'500\'></wow-error-page>',
                },
            },
        })
        .state('error.403', {
            url: '/unauthorisederror',
            views: {
                'center-panel@error': {
                    template: '<wow-error-page error-page="403"></wow-error-page>',
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/error.js